export var CART_ANALYTIC_EVENT = {
    category: 'cart',
    actions: {
        firstAdd: 'cart-first-item-added'
    },
    label: {
        cart: 'cart'
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/common/analytic-events/cartAnaltyicEvent.ts
// module id = null
// module chunks = 